enum FunctionKey {
  ALCHEMY = "ALCHEMY",
  NFTS = "NFTS",
  NFTS_METADATA = "NFTS_METADATA",
  LOCKS = "LOCKS",
}

export default FunctionKey;
